import useFlatNo from "./use-flat-no";

export default function useSubBuilding(property: string, street: string, org: string) {
  const flatNo = useFlatNo(property, street);

  if (org && org !== "" && flatNo && flatNo !== "") {
    return org + ", " + flatNo;
  }
  if (flatNo && flatNo !== "") {
    return flatNo;
  }
  if (org && org !== "") {
    return org;
  }
  return ""
}
